
<template>
  <el-dialog
    :title="title"
    :visible.sync="value"
    width="80%"
    :before-close="handleCloseDailog"
    @open="handleOpenDailog"
  >

    <div class="find">
      <div class="seach-top">
        <el-form
          ref="searchForm"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >
          <el-form-item
            label="关键字："
          >
            <el-input
              v-model="searchForm.keyWord"
              placeholder="请输入查询关键字"
              size="small"
              clearable
            />
          </el-form-item>
          <!-- 含已认领 -->
          <el-form-item>
            <el-checkbox v-model="searchForm.isConfirm">含已认领</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="handleSearch"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-table
      ref="renLingTable"
      class="table-list"
      :border="true"
      :data="tableData"
      style="width: 100%"
    >
      <!-- 序号 -->
      <el-table-column label="序号" type="index" width="50px" align="right" />
      <!-- 选择框 -->
      <el-table-column type="selection" align="center" />
      <!-- 名称 -->
      <el-table-column
        prop="projectName"
        label="课题名称"
        width="250"
        align="center"
      />
      <!-- 负责人 -->
      <el-table-column
        prop="createUserName"
        label="负责人"
        width="120"
        align="center"
      />
      <!-- 单位名称 -->
      <el-table-column
        prop="danWeiMingCheng"
        label="单位名称"
        width="250"
        align="center"
      />
      <!-- 部门/科研团队 -->
      <el-table-column
        prop="danWeiBuMenFullName"
        label="部门/科研团队"
        align="center"
      />

      <el-table-column
        fixed="right"
        label="操作"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.isCanBeEdit">
            <el-button
              v-if="!scope.row.isEdit"
              type="text"
              size="mini"
              plain
              @click.stop="handleEdit( scope.row,scope.$index)"
            >
              修改
            </el-button>
            <el-button
              v-if="scope.row.isEdit"
              type="text"
              size="small"
              @click.stop="handleSave(scope.row)"
            >
              保存
            </el-button>
            <el-button
              v-if="scope.row.isEdit"
              type="text"
              size="small"
              @click.stop="handleCancel(scope.row ,scope.$index)"
            >
              取消
            </el-button>
            <el-button
              v-if="!scope.row.isEdit"
              type="text"
              size="mini"
              @click.stop="handleDel(scope.row)"
            >
              删除
            </el-button>
          </span>
          <span v-else>
            <el-button
              type="text"
              size="small"
              @click.stop="handleShowDetail( scope.row,scope.$index)"
            >
              查看详细
            </el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleCloseDailog">取 消</el-button>
      <el-button
        type="primary"
        @click="handleSaveData"
      >认 领</el-button>
    </span>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'

export default {
  components: {
  },
  props: {
    value: Boolean,
    moduleCode: { type: String, default: '' }
  },
  data() {
    return {
      title: '项目认领',
      searchForm: {
        moduleCode: '',
        isConfirm: false,
        keyword: ''
      },
      tableData: []
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  activated() {
  },
  methods: {
    handleOpenDailog() {
      this.searchForm.moduleCode = this.moduleCode
      this.handleSearch()
    },
    handleCloseDailog() {
      this.$emit('input', false)
    },
    handleSearch() {
      // const loading = this.$loading(KxjCom.loadOptions)
      // const path = '/api/services/app/' + this.moduleCode + '/GetRenLingData'
      // const that = this
      // pathReq.getList(path, that.searchForm).then(res => {
      //   loading.close()
      //   that.tableData = res.data.result
      // })
      const that = this
      const path = '/api/services/app/WorkEventMemberNewService/GetKeTiRenlingList'
      const loading = this.$loading(KxjCom.loadOptions)
      pathReq.getList(path, that.searchForm).then(res => {
        loading.close()
        that.tableData = res.data.result
      })
    },
    handleSaveData() {
      // var moduleKeyList = this.$refs.renLingTable.selection.map((item) => item.id)
      // var data = {
      //   moduleCode: this.moduleCode,
      //   moduleKeyList: moduleKeyList
      // }
      // this.$loading(KxjCom.loadOptions)
      // const path = '/api/services/app/Com/ProjectRenLing'
      // pathReq.postForm(path, data).then(res => {
      //   this.$emit('save-success')
      //   this.$emit('input', false)
      // })
      var moduleKeyList = this.$refs.renLingTable.selection.map((item) => item.id)
      if (moduleKeyList.length === 0) {
        this.$message.error('请先选中要认领的课题')
        return
      }
      var data = {
        moduleCode: this.moduleCode,
        renlingKeys: moduleKeyList
      }
      this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/WorkEventMemberNewService/DoRenLing'
      pathReq.postForm(path, data).then(res => {
        this.$emit('save-success')
        this.$emit('input', false)
      })
    }
  }
}
</script>

